import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import { AppBar, Toolbar, Drawer, Typography, IconButton, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HeaderDrawer from './HeaderDrawer';
import useBoolean from '../hooks/useBoolean';

type BaseHeaderPropsType = {
  className?: string;
};

const BaseHeader: React.FC<BaseHeaderPropsType> = ({ className }) => {
  const { state, setTrue, setFalse } = useBoolean(false);

  return (
    <div className={className}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6">
            <Link to="/">佐渡 早川写真</Link>
          </Typography>
          <div style={{ flex: 1 }}></div>
          <IconButton
            onClick={() => setTrue()}
            edge="start"
            className="menu-button"
            color="inherit"
            aria-label="menu"
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer anchor={'right'} open={state} onClose={() => setFalse()}>
        <HeaderDrawer />
      </Drawer>
    </div>
  );
};

const Header = styled(BaseHeader)`
  ${() => {
    return css`
      & {
        margin-bottom: 20px;
        flex-grow: 1;
        menu-button: {
          margin-right: theme.spacing(2);
        }
        a {
          color: #ffffff;
          text-decoration: none;
          :hover {
            color: #ffffff;
            text-decoration: none;
          }
        }
        .MuiAppBar-colorPrimary {
          color: #fff;
          background-color: rgb(87, 139, 118);
        }
      }
    `;
  }}
`;

export default React.memo(Header);
